import { render } from "./PortfolioPage.vue?vue&type=template&id=a1928cb8&ts=true"
import script from "./PortfolioPage.vue?vue&type=script&lang=ts"
export * from "./PortfolioPage.vue?vue&type=script&lang=ts"

import "./PortfolioPage.vue?vue&type=style&index=0&id=a1928cb8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__